var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"bannerData":_vm.bannerData}}),_c('div',{staticClass:"container pt-4 pb-4 body"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-12-tablet is-12-desktop is-10-fullhd"},[_c('router-view',{on:{"bannerData":_vm.onBannerData}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }